











































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { routes, StrictRouteConfig } from "@/router/router";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "pageHeader",
})
export default class PageHeader extends Vue {
    @Prop()
    title: string;

    @Prop()
    subtitle: string;

    @Prop()
    paging: boolean;

    @Prop()
    nextRoute: StrictRouteConfig;

    @Prop()
    previousRoute: StrictRouteConfig;

    get breadcrumbs() {
        return [];

        if (!this.$route.meta.path || !this.$route.meta.path.length) return [];

        return this.$route.meta.path
            .map((routeName) => routes.find((r) => r.name === routeName))
            .map((r) => ({
                text: r.meta.label,
                to: { name: r.name },
                exact: true,
            }));
    }
}
